; (function ($, window, document, undefined) {

    var name = 'customCollection';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customCollection.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            if (this.options.requireInitReset) {
                setTimeout(() => {
                    this.$listings.empty();
                    this.addItem();
                }, 500);
            } else {
                this.$element.trigger('append.collection.item', [this, this.$listings.find('.item:first')]);
            }

            if (this.options.emptiable) {
                this.$element.addClass('emptiable');
            }
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$listings = this.$element.find('.listings:first');
            this.$item = this.$listings.find('.item:first').clone();
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('click', 'a[data-event="add-item"]:first', function () {
                plugin.addItem();
            });

            plugin.$element.on('click', 'a[data-event="remove-item"]', function () {
                if (plugin.$element.is($(this).closest('.collection'))) {
                    plugin.removeItem($(this).closest('.item'));
                }
            });
        },

        unbindEvents: function () {
            this.$element.off();
        },

        addItem: function (item = null) {
            var clone = this.$item.clone();

            this.$listings.append(clone);
            this.$element.trigger('append.collection.item', [this, clone]);

            if (item) {
                $.setInputValues(clone, this.options.specialSelectors.concat(['input', 'select', 'textarea']).join(), item);
            }

            return this;
        },

        removeItem: function (item) {
            item.remove();

            if (!this.$listings.find('>.item').length && !this.options.emptiable) {
                this.addItem();
            }

            return this;
        },

        val: function (items = null) {
            if (items) {
                this.$listings.find('>.item').remove();
                items.forEach(item => {
                    this.addItem(item);
                });

                this.$element.trigger('reset.collection.item', [this]);

                return this;
            }

            return this.$listings.find('>.item').map((index, row) => $.getInputValues(row, this.options.specialSelectors.concat(['input', 'select', 'textarea']).join(), this.$element)).toArray();
        },
    });

    $.fn.customCollection = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customCollection.defaults = {
        emptiable: false,
        requireInitReset: false,
        specialSelectors: [],
    };
})(jQuery, window, document);
